import React from 'react';

const StatusBadge = ({ status, type = 'default', size = 'md', className = '' }) => {
  const getStatusConfig = () => {
    const statusLower = status?.toLowerCase() || '';
    
    // Payment/Transaction statuses
    if (statusLower === 'paid' || statusLower === 'completed' || statusLower === 'approved' || statusLower === 'active') {
      return {
        bg: 'bg-green-100',
        text: 'text-green-800',
        icon: '✓'
      };
    }
    if (statusLower === 'pending' || statusLower === 'partial' || statusLower === 'issued' || statusLower === 'processing') {
      return {
        bg: 'bg-yellow-100',
        text: 'text-yellow-800',
        icon: '⏳'
      };
    }
    if (statusLower === 'overdue' || statusLower === 'suspended' || statusLower === 'blocked' || statusLower === 'cancelled') {
      return {
        bg: 'bg-red-100',
        text: 'text-red-800',
        icon: '⚠'
      };
    }
    if (statusLower === 'in_progress' || statusLower === 'shipped' || statusLower === 'delivered') {
      return {
        bg: 'bg-blue-100',
        text: 'text-blue-800',
        icon: '→'
      };
    }
    if (statusLower === 'draft' || statusLower === 'inactive') {
      return {
        bg: 'bg-gray-100',
        text: 'text-gray-800',
        icon: '○'
      };
    }
    
    // Credit statuses
    if (statusLower === 'good' || statusLower === 'excellent') {
      return {
        bg: 'bg-green-100',
        text: 'text-green-800',
        icon: '★'
      };
    }
    if (statusLower === 'warning' || statusLower === 'attention') {
      return {
        bg: 'bg-yellow-100',
        text: 'text-yellow-800',
        icon: '!'
      };
    }
    if (statusLower === 'bad' || statusLower === 'default') {
      return {
        bg: 'bg-red-100',
        text: 'text-red-800',
        icon: '!!'
      };
    }
    
    // Stock statuses
    if (statusLower === 'in_stock' || statusLower === 'available') {
      return {
        bg: 'bg-green-100',
        text: 'text-green-800',
        icon: '●'
      };
    }
    if (statusLower === 'low_stock' || statusLower === 'limited') {
      return {
        bg: 'bg-yellow-100',
        text: 'text-yellow-800',
        icon: '●'
      };
    }
    if (statusLower === 'out_of_stock' || statusLower === 'unavailable') {
      return {
        bg: 'bg-red-100',
        text: 'text-red-800',
        icon: '●'
      };
    }
    
    // Default
    return {
      bg: 'bg-gray-100',
      text: 'text-gray-800',
      icon: ''
    };
  };

  const sizes = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-2.5 py-0.5 text-xs',
    lg: 'px-3 py-1 text-sm'
  };

  const config = getStatusConfig();
  
  const formatStatus = (status) => {
    if (!status) return '';
    return status.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  };

  return (
    <span 
      className={`inline-flex items-center rounded-full font-medium ${sizes[size]} ${config.bg} ${config.text} ${className}`}
      role="status"
    >
      {config.icon && (
        <span className="mr-1" aria-hidden="true">
          {config.icon}
        </span>
      )}
      {formatStatus(status)}
    </span>
  );
};

export default StatusBadge;